import {FeatureState} from '../page-data/payloads/header'
import type {FeatureStates} from '../page-data/payloads/header'
import {useLayoutRouteData} from '../page-data/loaders/use-layout-route-data'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsLayoutRoute} from '../routes/layout-route'

import {makeSelectDataFromQueryData} from '@github-ui/react-core/future/main-query'
import type {LayoutRoutePayload} from '../routes/route-payload-types'

const EMPTY_FEATURE_STATES: Readonly<FeatureStates> = Object.freeze({})

export function useFeatureState(feature: keyof FeatureStates): FeatureState {
  const featureStates = useFeatureStates()
  return featureStates[feature] ?? FeatureState.Unavailable
}

export function useFeatureStates(): FeatureStates {
  const {featureStates} = useLayoutRouteData()
  return featureStates ?? EMPTY_FEATURE_STATES
}

const selectLayoutPayload = makeSelectDataFromQueryData<LayoutRoutePayload>()

export function useIsFeatureStateEnabled(feature: keyof FeatureStates): boolean {
  const {data} = useRouteQuery(pullRequestsLayoutRoute, 'mainQuery', {
    select: raw => selectLayoutPayload(raw).featureStates?.[feature] === FeatureState.Enabled,
    notifyOnChangeProps: ['data'],
  })

  return data
}
